/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { useTheme } from '../../ThemeProvider';
import { createStyles } from '../../utils';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';

interface Props {
  textToCopy: string;
  title?: string;
  text?: string;
  testId?: string;
}

export const Copy = ({ textToCopy, title, text, testId }: Props) => {
  const styles = useStyles();
  const [copied, setCopied] = useState(false);
  const { spacing } = useTheme();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <Tooltip
      title={title || 'Copied to clipboard'}
      open={copied}
      onClose={() => setCopied(false)}
      placement="top-end"
    >
      <div
        data-testid={testId || 'copy'}
        aria-label={!text ? 'Copy' : undefined}
        css={[
          styles.copy,
          text
            ? {
                padding: `${spacing.xxxs} ${spacing.xxs}`,
              }
            : {},
        ]}
        onClick={copyToClipboard}
      >
        <Icon name="copy" />
        {text && <Typography variant="bodyMedium">{text}</Typography>}
      </div>
    </Tooltip>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  copy: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xxxs,
    cursor: 'pointer',
  },
}));
